import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import ClearIcon from "@mui/icons-material/Clear";

export type BulkActionBarProps = {
  selectedCount: number;
  isBusy: boolean;
  onEnable: () => void;
  onDisable: () => void;
  onClear: () => void;
};

export const BulkActionBar = ({
  selectedCount,
  isBusy,
  onEnable,
  onDisable,
  onClear,
}: BulkActionBarProps) => {
  if (selectedCount === 0) return null;
  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: (t) => t.zIndex.appBar - 1,
        mt: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 1.5,
          display: "flex",
          alignItems: "center",
          gap: 2,
          borderRadius: 2,
        }}
      >
        <Typography sx={{ fontWeight: 600 }}>
          {selectedCount} selected
        </Typography>
        <Stack direction="row" spacing={1} sx={{ ml: "auto" }}>
          <Button
            size="small"
            variant="contained"
            startIcon={<CheckCircleIcon />}
            onClick={onEnable}
            disabled={isBusy}
          >
            Enable
          </Button>
          <Button
            size="small"
            variant="outlined"
            startIcon={<BlockIcon />}
            onClick={onDisable}
            disabled={isBusy}
          >
            Disable
          </Button>
          <Button
            size="small"
            startIcon={<ClearIcon />}
            onClick={onClear}
            disabled={isBusy}
          >
            Clear
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};
